//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { ChangeColMixin } from '@/mixins/ChangeColMixin';
import moment from 'moment';
export default {
  name: 'St21Cn2011List',
  data: function data() {
    return {
      cols: [{
        title: '监测时间',
        align: 'center',
        width: 150,
        dataIndex: 'dataTime',
        colName: 'data_time'
      }],
      url: '/st21/cn2011'
    };
  },
  mixins: [GetSiteIdMixin, ChangeColMixin],
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();

      if (ids[0] == '1') {
        this.queryParam.id = ids[1];
        this.queryParam.type = '1';
        this.loadData();
      } else {
        this.queryParam.id = ids[1];
        this.queryParam.type = '2';
        this.loadData();
      }
    }
  },
  methods: {
    onDateChange: function onDateChange(value, dateString) {
      console.log(dateString[0], dateString[1]);
      this.queryParam.stime = dateString[0];
      this.queryParam.etime = dateString[1];
      this.loadData();
    }
  }
};